/**
 * @author Rahul Nainala
 * @description 
 */
import '../CSS/eLog.css';
import styles from '../CSS/style.less';
import React, { useState, useEffect, useCallback } from 'react';
import StyledTable from '../../../../commons/styles/table';

const TableViewExpandView = (props) => {
  const [columns, setColumns] = useState((props.form && props.form.columns) || []);
  const [data, setData] = useState(
    (props.form && props.form.datasource)
      ? props.form.datasource.map((dataSource, index) => ({
        ...dataSource,
        key: index + 1
      }))
      : []
  );
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [selectedRowKeys1, setSelectedRowKeys1] = useState([]);

  useEffect(() => {
    setColumns((props.form && props.form.columns) || []);
    setData(
      (props.form && props.form.datasource)
        ? props.form.datasource.map((dataSource, index) => ({
          ...dataSource,
          key: index + 1
        }))
        : []
    );
  }, [props.form]);

  useEffect(() => {
    if (props.form && props.form.problem && props.form.cause) {
      setSelectedRowKeys(props.form && props.form.problem ? props.form.problem : []);
      setSelectedRowKeys1(props.form && props.form.cause ? props.form.cause : []);
    }
  }, [props.form]);

  const onSelectChange = useCallback((selectedRowKeys) => {
    props.saveTableViewDataCustom(selectedRowKeys[0], 'problem');
    setSelectedRowKeys([selectedRowKeys[0]]);
  }, [props]);

  const onSelectChange1 = useCallback((selectedRowKeys1) => {
    props.saveTableViewDataCustom(selectedRowKeys1[0], 'cause');
    setSelectedRowKeys1([selectedRowKeys1[0]]);
  }, [props]);

  const rowSelection = {
    selectedRowKeys,
    onChange: onSelectChange
  };

  const rowSelection1 = {
    selectedRowKeys1,
    onChange: onSelectChange1
  };

  return (
    <div className="tableView" style={{ marginTop: '80px' }}>
      <div>
        <StyledTable size="small"
          key="mainTable"
          loading={props.loading}
          columns={columns}
          dataSource={data}
          pagination={false}
          style={{ marginTop: '10px', border: '1px solid  red !important' }}
          rowClassName={(record) => (record.editable ? styles.editable : '')}
          rowSelection={rowSelection}
          expandedRowRender={(record) => (
            <p style={{ margin: 0 }}>
              <StyledTable size="small"
                key="childTable"
                rowSelection={rowSelection1}
                columns={columns}
                dataSource={record.child}
                bordered
              />
            </p>
          )}
        />
      </div>
    </div>
  );
};

export default TableViewExpandView;
